import styles from "./css/ChipView.module.css";

interface ChipViewProps {
  title: string;
  style: ChipViewStyle;
}

export enum ChipViewStyle {
  normal,
  correct,
  incorrect,
}

export default function ChipView(props: ChipViewProps) {
  function getTitleColor() {
    switch (props.style) {
      case ChipViewStyle.normal:
        return "var(--text-secondary-color)";
      case ChipViewStyle.correct:
        return "var(--text-primary-inverted-color)";
      case ChipViewStyle.incorrect:
        return "var(--text-primary-inverted-color)";
    }
  }

  function getBackgroundColor() {
    switch (props.style) {
      case ChipViewStyle.normal:
        return "var(--chip-label-background-color)";
      case ChipViewStyle.correct:
        return "var(--level-three-color)";
      case ChipViewStyle.incorrect:
        return "var(--level-one-color)";
    }
  }

  const containerStyle = {
    backgroundColor: getBackgroundColor(),
  };

  const textStyle = {
    color: getTitleColor(),
  };

  return (
    <>
      <div className={styles.container} style={containerStyle}>
        <span className={styles.titleText} style={textStyle}>
          {props.title}
        </span>
      </div>
    </>
  );
}
